import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import Searchbar from './Searchbar';

const ContactPage = () => {
    const { t, i18n } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    return (
        <div className='container bg-[#fdfdfd] min-h-screen">
'>
             <Helmet>
            <html lang={i18n.language} />
            <title>
                {i18n.language === 'ar' ? 'اتصل بنا | PriceAlertz' : 'Contact Us | PriceAlertz'}
            </title>
            <meta
                name="description"
                content={
                    i18n.language === 'ar'
                        ? 'تواصل معنا لأية استفسارات أو ملاحظات. نحن هنا للمساعدة.'
                        : 'Contact us for any inquiries or feedback. We are here to assist you.'
                }
            />
            <meta
                name="keywords"
                content={
                    i18n.language === 'ar'
                        ? 'اتصل، الدعم، استفسارات، مساعدة، PriceAlertz'
                        : 'contact, support, inquiries, help, PriceAlertz'
                }
            />
        </Helmet>
        <Header />
            <Searchbar 
                    placeholder={t('searchbar.landingPage')} 
                    onSearchSubmit={(value) => {
                        // handle the actual search logic here
                        console.log('User searched:', value);
                        // maybe call your API or filter state, etc.
                      }}
                    />
        <div className="max-w-2xl mx-auto px-4 py-12">
  <h1 className="text-center mb-8 text-2xl pt-4 font-semibold text-[rgb(62,43,205)]">
    {t('contactUs.title')}
  </h1>
  <p className='text-md text-gray-600'>We're just a message away — whether it's a question, suggestion, or a hello, feel free to reach out!</p>
  <form
    name="contact"
    method="POST"
    data-netlify="true"
    netlify-honeypot="bot-field"
    netlify
    className="space-y-6 bg-white p-6 rounded-2xl shadow-md"
  >
    {/* Hidden input for Netlify */}
    <input type="hidden" name="form-name" value="contact" />
    <p className="hidden">
      <label>Don’t fill this out: <input name="bot-field" /></label>
    </p>

    <input
      type="text"
      name="name"
      value={formData.name}
      onChange={handleInputChange}
      placeholder={t('contactUs.namePlaceholder')}
      className="w-full border border-gray-300 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-[#FF9900] dark:bg-slate-600"
      required
    />

    <input
      type="email"
      name="email"
      value={formData.email}
      onChange={handleInputChange}
      placeholder={t('contactUs.emailPlaceholder')}
      className="w-full border border-gray-300 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-[#FF9900] dark:bg-slate-600"
      required
    />

    <input
      type="text"
      name="subject"
      value={formData.subject}
      onChange={handleInputChange}
      placeholder={t('contactUs.subjectPlaceholder')}
      className="w-full border border-gray-300 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-[#FF9900] dark:bg-slate-600"
      required
    />

    <textarea
      name="message"
      value={formData.message}
      onChange={handleInputChange}
      placeholder={t('contactUs.messagePlaceholder')}
      className="w-full border border-gray-300 p-3 rounded-xl h-40 resize-none focus:outline-none focus:ring-2 focus:ring-[#FF9900] focus:border-[#FF9900] dark:bg-slate-600"
      required
    ></textarea>

    <button
      type="submit"
      className="w-full bg-[#FF9900] text-white py-3 rounded-xl font-semibold hover:bg-[rgb(62,43,205)] transition duration-200"
    >
      {t('contactUs.submitButton')}
    </button>
  </form>
</div>
          <Footer />
        </div>
    );
};

export default ContactPage;


